function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.959.032c1.156 0 2.186.597 2.757 1.602l5.766 9.985c.574.994.57 2.183-.008 3.18a3.168 3.168 0 01-2.768 1.606H3.189a3.15 3.15 0 01-2.75-1.58 3.168 3.168 0 01-.011-3.199L6.201 1.63A3.144 3.144 0 018.959.032zm0 1.444c-.634 0-1.193.324-1.506.872L1.68 12.34a1.744 1.744 0 00.003 1.757c.313.54.877.861 1.503.861h11.516c.633 0 1.2-.328 1.52-.88.317-.548.32-1.196.012-1.734l-5.77-9.992a1.714 1.714 0 00-1.505-.876zm-.004 10.062c.504 0 .92.416.898.942.022.479-.416.899-.898.899a.93.93 0 01-.92-.92.93.93 0 01.92-.921zm-.228-6.462a.923.923 0 011.064.52c.062.147.084.294.084.46-.022.46-.062.92-.084 1.38-.04.711-.085 1.422-.126 2.132-.022.232-.022.442-.022.67a.687.687 0 01-.688.67.674.674 0 01-.689-.648l-.187-3.302-.063-.876c0-.483.272-.88.71-1.006z",
  fill: "#FFF",
  fillRule: "nonzero"
});

function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _ref);
}

export default SvgError;